import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Ellipsis as EllipsisHorizontalIcon } from "@air/next-icons";
import { memo } from "react";
import { CardAction } from "~/components/CardAction";
import { AssetGalleryCardMenu } from "~/components/Gallery/AssetGalleryCard/AssetGalleryCardMenu";
import { ASSET_CARD_SUB_MENU_BUTTON } from "~/constants/testIDs";
const _AssetGalleryCardRightActions = (param)=>{
    let { clip, getItemMenuOptions, getSelectionMenuOptions, setIsMenuOpen } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(AssetGalleryCardMenu, {
            clip: clip,
            getItemMenuOptions: getItemMenuOptions,
            getSelectionMenuOptions: getSelectionMenuOptions,
            setIsMenuOpen: setIsMenuOpen,
            trigger: /*#__PURE__*/ _jsx(CardAction, {
                "data-testid": ASSET_CARD_SUB_MENU_BUTTON,
                icon: /*#__PURE__*/ _jsx(EllipsisHorizontalIcon, {
                    className: "size-4"
                })
            })
        })
    });
};
export const AssetGalleryCardRightActions = /*#__PURE__*/ memo(_AssetGalleryCardRightActions);
